
<template>
    <div class="rests_times">
        <b-overlay :show="is_load" rounded="sm">
            <times v-if="api_load" :times="this.times_data"></times>
            <div class="sync_it w-100 mt-4">
                <button type="button" v-on:click="sync_times" class="btn btn-primary waves-effect waves-themed w-100">
                    {{__t('SYNC_TIME')}}
                </button>
            </div>
        </b-overlay>
    </div>
</template>


<script>
import times from "../../../../times/times";
export default {
    name: "wolt_work_hour",
    props : {
        location : {
            type : Object
        }
    },
    components : {
        times
    },

    mounted () {
        this.load_times();
    },

    data() {
        return {
            cur_rest : this.rest,
            is_load: false,
            api_load : false,
            times_data : [],
        }
    },

    methods : {

        async load_times() {
            this.times_data = [];
            this.is_load = true;
            this.api_load = false;

            agr_api.get('/aggregators/wolt/location/' + this.location.id + "/time").then(({data}) => {
                this.is_load = false;
                this.api_load = true;
                this.times_data = data.data;

            }).catch(({response}) => {
                this.is_load = false;
                this.api_load = true;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async sync_times() {
            this.is_load = true;
            agr_api.patch('/aggregators/wolt/location/' + this.location.id + "/time",{'times' : this.times_data}).then(({data}) => {
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    }
}
</script>


<style scoped>

</style>
